import hcOffcanvasNav from 'hc-offcanvas-nav';
import 'hc-offcanvas-nav/dist/hc-offcanvas-nav.css';

hcOffcanvasNav('.mobile-nav', {
	activeToggle: '.nav-trigger',
  labelBack: 'Zurück',
});
